import Mermaid from './Mermaid';

export type { MermaidProps, MermaidType } from './Mermaid';

export default Mermaid;
